module.exports = __webpack_public_path__ + "static/media/tc.d40761f2.svg";